/* ---------------------------------------------------------------------------
   UF KEY STATS — the Front / Back of pack switch.

   Deliberately LOCAL and deliberately FORGETFUL. It sets data-uf-stats-face on
   its own section and nothing else, and it is not remembered between visits.

   Both of those are reactions to the page-wide mode this replaces. That one
   stored its choice in localStorage and repainted every section from an
   attribute on <html>, so a visitor who had flipped it once kept getting a dark
   Key Stats on every later visit — and when the toggle was switched off, the
   attribute was still being restored with no control left to undo it.

   Turning a tub over is also just not a preference. It is something you do
   once, to read the label, and then you are done.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  /* One delegated listener however many times this file is included. A second
     copy would toggle each click twice and land back where it started, which
     reads as a broken switch rather than a double-loaded script. */
  if (window.__ufStatsFlipBound) return;
  window.__ufStatsFlipBound = true;

  function setFace(section, face) {
    section.setAttribute('data-uf-stats-face', face);

    Array.prototype.slice
      .call(section.querySelectorAll('[data-uf-stats-view]'))
      .forEach(function (btn) {
        btn.setAttribute(
          'aria-checked',
          String(btn.getAttribute('data-uf-stats-view') === face)
        );
      });
  }

  document.addEventListener('click', function (event) {
    var btn =
      event.target.closest && event.target.closest('[data-uf-stats-view]');
    if (!btn) return;

    var section = btn.closest('[data-uf-stats-flip]');
    if (!section) return;

    setFace(section, btn.getAttribute('data-uf-stats-view'));
  });

  /* Arrow keys move between the options, which is what a radiogroup is expected
     to do — without it the control is reachable but not operable the way a
     keyboard user will reach for it. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    var btn =
      event.target.closest && event.target.closest('[data-uf-stats-view]');
    if (!btn) return;

    var section = btn.closest('[data-uf-stats-flip]');
    if (!section) return;

    var buttons = Array.prototype.slice.call(
      section.querySelectorAll('[data-uf-stats-view]')
    );
    if (buttons.length < 2) return;

    var next =
      buttons[
        (buttons.indexOf(btn) +
          (event.key === 'ArrowRight' ? 1 : -1) +
          buttons.length) %
          buttons.length
      ];

    event.preventDefault();
    setFace(section, next.getAttribute('data-uf-stats-view'));
    next.focus();
  });
})();
